import Views from "@/views";
import Layout from "@/components/Layouts/Index.vue";

/* Views */
const { dutiesView, usersView, usersEditView ,permissionsView} = Views;

const securityRouter = {
  path: "/security",
  component: Layout,
  redirect: "dashboard",
  name: "",
  history: false,
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: "users",
      name: "Users",
      component: usersView,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "duties",
      name: "Duties",
      component: dutiesView,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "permissions",
      name: "Permisos",
      component: permissionsView,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "users/edit/:id",
      name: "UsersEdit",
      component: usersEditView,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },

  ],
};

export default securityRouter;
